// src/services/monografiaService.js
import api from '../services/api';

// ============================================
// FUNÇÕES EXISTENTES (mantidas)
// ============================================
export const listarMonografias = async () => {
    return api.get('/monografias');
};

export const obterMonografia = async (id) => {
    return api.get(`/monografias/${id}`);
};

export const criarMonografia = async (monografia) => {
    return api.post('/monografias', monografia, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    });
};

export const atualizarMonografia = async (id, monografia) => {
    return api.put(`/monografias/${id}`, monografia);
};

export const excluirMonografia = async (id) => {
    return api.delete(`/monografias/${id}`);
};

// Função para obter similaridade
// src/services/monografiaService.js

// FUNÇÃO COMPLETA obterSimilaridadeMonografia - MANTENDO TODA LÓGICA ORIGINAL
// FUNÇÃO COMPLETA obterSimilaridadeMonografia - MANTENDO TODA LÓGICA ORIGINAL
// FUNÇÃO COMPLETA obterSimilaridadeMonografia - MANTENDO TODA LÓGICA ORIGINAL
export const obterSimilaridadeMonografia = async (id) => {
    try {
      const response = await api.get(`/monografias/${id}/similaridade`);
      console.log('Dados brutos de similaridade recebidos:', response.data);
  
      // 1) Extrai o array de similaridades - 🔥 CORREÇÃO PRINCIPAL
      const raw = response.data.similares; // ✅ Era .similaridade, agora .similares
      const similares = Array.isArray(raw)
        ? raw.map(item => ({
            tipo: item.tipo,
            id: item.id, // ✅ Usar item.id diretamente (já vem correto)
            score: item.score, // ✅ Já vem como porcentagem (39, não 0.39)
            similaridadeDireta: parseFloat(item.similaridadeDireta || 0),
            jaroWinkler: parseFloat(item.jaroWinkler || 0),
            termosComuns: item.termosComuns || [],
            trechosSimilares: item.trechosSimilares || [],
            documentoOriginal: item.documentoOriginal || {}, // ✅ Usar diretamente
            mensagem: item.mensagem
          }))
        : [];
  
      // 2) 🔥 CORREÇÃO: Extrai dados de anti-plágio diretamente (não do metadata)
      const antiPlagio = response.data.antiPlagio || {
        sistemaHibrido: false,
        threshold: 0.3,
        totais: {}
      };
  
      // 3) 🔥 CORREÇÃO: Extrai dados de IA diretamente (não como 'ia')
      const iaRaw = response.data.iaDetection;
      const iaDetection = iaRaw && iaRaw.disponivel
        ? {
            disponivel:    true,
            score:         iaRaw.score,               // já em 0–100
            classificacao: iaRaw.classificacao,
            recomendacao:  iaRaw.recomendacao || iaRaw.recomendacoes,
            detalhes:      iaRaw.detalhes
          }
        : { disponivel: false };
  
      return { similares, antiPlagio, iaDetection };
    } catch (error) {
      console.error('Erro ao obter similaridade da monografia:', error);
      throw error;
    }
  };
  

// ============================================
// FUNÇÕES EXISTENTES DE REVISÃO (mantidas)
// ============================================
export const encaminharMonografiaParaRevisao = async (idMonografia, idRevisor) => {
    return api.post('/monografias/encaminhar-revisor', { 
      monografiaId: idMonografia, 
      revisorId: idRevisor 
    });
};

export const devolverMonografia = async (idMonografia, comentario) => {
    return api.put(`/monografias/${idMonografia}/devolver`, {
      comentario, 
    });
};

export const voltarMonografiaParaRevisao = async (idMonografia) => {
    return api.put(`/monografias/${idMonografia}/emrevisao`);
};

export const registrarParecerMonografia = async (monografiaId, parecer, recomendacao) => {
    return api.post('/monografias/registrar-parecer', {
      monografiaId,
      parecer,
      recomendacao
    });
};

export const aprovarMonografia = async (idMonografia) => {
    return api.put(`/monografias/${idMonografia}/aprovar`, {
      monografiaId: idMonografia
    });
};

export const listarMonografiasPorRevisor = async (revisorId) => {
    return api.get(`/monografias?revisorId=${revisorId}`);
};

// ============================================
// NOVAS FUNÇÕES PARA O FLUXO COMPLETO
// ============================================

// ============================
// FUNÇÕES DO SUPERVISOR
// ============================

/**
 * Listar monografias do supervisor logado
 */
export const listarMonografiasPorSupervisor = async () => {
    try {
        console.log('🔍 Buscando monografias do supervisor...');
        const response = await api.get('/monografias/supervisor/minhas');
        console.log('✅ Monografias do supervisor:', response.data);
        return response;
    } catch (error) {
        console.error('❌ Erro ao listar monografias do supervisor:', error);
        throw error;
    }
};

/**
 * Supervisor marca monografia como em análise
 * Transição: SUBMETIDA → EM_ANALISE
 */
export const marcarMonografiaEmAnalise = async (id) => {
    try {
        console.log(`🔄 Marcando monografia ${id} como em análise...`);
        const response = await api.put(`/monografias/${id}/marcar-em-analise`);
        console.log('✅ Monografia marcada como em análise:', response.data);
        return response;
    } catch (error) {
        console.error('❌ Erro ao marcar monografia como em análise:', error);
        throw error;
    }
};

/**
 * Supervisor solicita correções
 * Transição: EM_ANALISE → CORRECOES_SOLICITADAS
 */
export const solicitarCorrecoes = async (id, observacoes, prazoCorrecao = null) => {
    try {
        console.log(`📝 Solicitando correções para monografia ${id}...`);
        const payload = {
            observacoes,
            ...(prazoCorrecao && { prazo_correcao: prazoCorrecao })
        };
        
        const response = await api.put(`/monografias/${id}/solicitar-correcoes`, payload);
        console.log('✅ Correções solicitadas:', response.data);
        return response;
    } catch (error) {
        console.error('❌ Erro ao solicitar correções:', error);
        throw error;
    }
};

/**
 * Supervisor aprova monografia
 * Transição: EM_ANALISE → APROVADA_PELO_SUPERVISOR
 */
// Para o supervisor:
export const aprovarMonografiaPeloSupervisor = async (id, observacoesAprovacao = '') => {
  return api.put(`/monografias/${id}/aprovar`, {
      observacoes_aprovacao: observacoesAprovacao
  });
};

// Para o chefe de departamento:
export const aprovarMonografiaPeloChefe = async (idMonografia) => {
  return api.put(`/monografias/${idMonografia}/aprovar-chefe`, {
      monografiaId: idMonografia
  });
};

export async function obterHistoricoMonografia(monografiaId) {
  return api.get(`/monografias/${monografiaId}/historico`);
}

// ============================
// FUNÇÕES DO ESTUDANTE
// ============================

/**
 * Estudante resubmete monografia após correções
 * Transição: CORRECOES_SOLICITADAS → EM_ANALISE
 */
export const resubmeterMonografiaAposCorrecoes = async (id, arquivo = null) => {
    try {
        console.log(`🔄 Resubmetendo monografia ${id} após correções...`);
        
        const formData = new FormData();
        if (arquivo) {
            formData.append('documentoMonografia', arquivo);
        }

        const response = await api.put(`/monografias/${id}/resubmeter`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        
        console.log('✅ Monografia resubmetida:', response.data);
        return response;
    } catch (error) {
        console.error('❌ Erro ao resubmeter monografia:', error);
        throw error;
    }
};

export async function obterEstatisticasVersionamento(monografiaId) {
  return api.get(`/monografias/${monografiaId}/estatisticas`);
}

export async function obterVersaesDocumentos(monografiaId) {
  return api.get(`/monografias/${monografiaId}/versoes`);
}


/**
 * Estudante submete monografia à Direção Científica
 * Transição: APROVADA_PELO_SUPERVISOR → SUBMETIDA_A_DIRECCAO_CIENTIFICA
 */
export const submeterParaDirecaoCientifica = async (id) => {
    try {
        console.log(`🏛️ Submetendo monografia ${id} à Direção Científica...`);
        const response = await api.put(`/monografias/${id}/submeter-direcao`);
        console.log('✅ Monografia submetida à Direção Científica:', response.data);
        return response;
    } catch (error) {
        console.error('❌ Erro ao submeter à Direção Científica:', error);
        throw error;
    }
};

// ============================
// FUNÇÕES DA DIREÇÃO CIENTÍFICA
// ============================

/**
 * Direção marca monografia como em análise
 * Transição: SUBMETIDA_A_DIRECCAO_CIENTIFICA → EM_ANALISE_DIRECCAO_CIENTIFICA
 */
export const marcarEmAnalisePelaDirecao = async (id) => {
    try {
        console.log(`🔍 Marcando monografia ${id} como em análise pela Direção...`);
        const response = await api.put(`/monografias/${id}/marcar-analise-direcao`);
        console.log('✅ Monografia em análise pela Direção:', response.data);
        return response;
    } catch (error) {
        console.error('❌ Erro ao marcar para análise da Direção:', error);
        throw error;
    }
};

/**
 * Direção devolve monografia
 * Transição: EM_ANALISE_DIRECCAO_CIENTIFICA → DEVOLVIDA_PELA_DIRECCAO_FORMAL/CONTEUDO
 */
export const devolverPelaDirecao = async (id, tipoDevolucao, observacoes) => {
    try {
        console.log(`↩️ Direção devolvendo monografia ${id} (${tipoDevolucao})...`);
        
        if (!['FORMAL', 'CONTEUDO'].includes(tipoDevolucao)) {
            throw new Error('Tipo de devolução deve ser FORMAL ou CONTEUDO');
        }
        
        const response = await api.put(`/monografias/${id}/devolver-direcao`, {
            tipo_devolucao: tipoDevolucao,
            observacoes
        });
        
        console.log('✅ Monografia devolvida pela Direção:', response.data);
        return response;
    } catch (error) {
        console.error('❌ Erro ao devolver pela Direção:', error);
        throw error;
    }
};

/**
 * Direção aprova monografia definitivamente
 * Transição: EM_ANALISE_DIRECCAO_CIENTIFICA → APROVADA_PELA_DIRECCAO_CIENTIFICA
 */
export const aprovarPelaDirecao = async (id, observacoesAprovacao = '') => {
    try {
        console.log(`🎯 Direção aprovando monografia ${id} definitivamente...`);
        const response = await api.put(`/monografias/${id}/aprovar-direcao`, {
            observacoes_aprovacao: observacoesAprovacao
        });
        console.log('🏆 Monografia aprovada definitivamente:', response.data);
        return response;
    } catch (error) {
        console.error('❌ Erro ao aprovar pela Direção:', error);
        throw error;
    }
};

// ============================
// FUNÇÕES UTILITÁRIAS
// ============================

/**
 * Obter status traduzido para exibição
 */
export const getStatusDisplayName = (status) => {
    const statusMap = {
        'RASCUNHO': 'Rascunho',
        'SUBMETIDA': 'Submetida ao Supervisor',
        'EM_ANALISE': 'Em Análise pelo Supervisor',
        'CORRECOES_SOLICITADAS': 'Correções Solicitadas',
        'APROVADA_PELO_SUPERVISOR': 'Aprovada pelo Supervisor',
        'SUBMETIDA_A_DIRECCAO_CIENTIFICA': 'Submetida à Direção Científica',
        'EM_ANALISE_DIRECCAO_CIENTIFICA': 'Em Análise pela Direção',
        'DEVOLVIDA_PELA_DIRECCAO_FORMAL': 'Devolvida (Problemas Formais)',
        'DEVOLVIDA_PELA_DIRECCAO_CONTEUDO': 'Devolvida (Problemas de Conteúdo)',
        'APROVADA_PELA_DIRECCAO_CIENTIFICA': 'Aprovada Definitivamente',
        
        // Status antigos (compatibilidade)
        'EM_REVISAO': 'Em Revisão',
        'DEVOLVIDA': 'Devolvida',
        'REVISTO': 'Revisada',
        'APROVADA': 'Aprovada'
    };
    
    return statusMap[status] || status;
};

/**
 * Obter cor do status para exibição
 */
export const getStatusColor = (status) => {
    const colorMap = {
        'RASCUNHO': 'default',
        'SUBMETIDA': 'info',
        'EM_ANALISE': 'warning',
        'CORRECOES_SOLICITADAS': 'error',
        'APROVADA_PELO_SUPERVISOR': 'success',
        'SUBMETIDA_A_DIRECCAO_CIENTIFICA': 'info',
        'EM_ANALISE_DIRECCAO_CIENTIFICA': 'warning',
        'DEVOLVIDA_PELA_DIRECCAO_FORMAL': 'error',
        'DEVOLVIDA_PELA_DIRECCAO_CONTEUDO': 'error',
        'APROVADA_PELA_DIRECCAO_CIENTIFICA': 'success',
        
        // Status antigos
        'EM_REVISAO': 'warning',
        'DEVOLVIDA': 'error',
        'REVISTO': 'info',
        'APROVADA': 'success'
    };
    
    return colorMap[status] || 'default';
};

/**
 * Verificar se o usuário pode executar determinada ação
 */
export const canUserPerformAction = (userType, status, action) => {
    const permissions = {
        'supervisor': {
            'SUBMETIDA': ['marcar-em-analise'],
            'DEVOLVIDA_PELA_DIRECCAO_FORMAL': ['marcar-em-analise'],
            'DEVOLVIDA_PELA_DIRECCAO_CONTEUDO': ['marcar-em-analise'],
            'EM_ANALISE': ['solicitar-correcoes', 'aprovar'],
        },
        'estudante': {
            'CORRECOES_SOLICITADAS': ['resubmeter'],
            'APROVADA_PELO_SUPERVISOR': ['submeter-direcao'],
        },
        'chefe_departamento': {
            'SUBMETIDA_A_DIRECCAO_CIENTIFICA': ['marcar-analise-direcao'],
            'EM_ANALISE_DIRECCAO_CIENTIFICA': ['devolver-direcao', 'aprovar-direcao'],
        },
        'direcao_cientifica': {
            'SUBMETIDA_A_DIRECCAO_CIENTIFICA': ['marcar-analise-direcao'],
            'EM_ANALISE_DIRECCAO_CIENTIFICA': ['devolver-direcao', 'aprovar-direcao'],
        }
    };
    
    const userPermissions = permissions[userType];
    if (!userPermissions) return false;
    
    const statusPermissions = userPermissions[status];
    if (!statusPermissions) return false;
    
    return statusPermissions.includes(action);
};

/**
 * Obter documento corrigido anexado pelo supervisor
 * @param {number} monografiaId - ID da monografia
 * @returns {Promise} - Response com URL de download
 */
export const obterDocumentoCorrigido = async (monografiaId) => {
  try {
      console.log(`📥 Obtendo documento corrigido da monografia ${monografiaId}...`);
      const response = await api.get(`/monografias/${monografiaId}/documento-corrigido`);
      console.log('✅ Documento corrigido obtido:', response.data);
      return response;
  } catch (error) {
      console.error('❌ Erro ao obter documento corrigido:', error);
      throw error;
  }
};

/**
 * Obter próximas ações disponíveis para um status
 */
export const getAvailableActions = (userType, status) => {
    const actions = [];
    
    if (canUserPerformAction(userType, status, 'marcar-em-analise')) {
        actions.push({
            key: 'marcar-em-analise',
            label: 'Marcar como Em Análise',
            color: 'primary',
            icon: 'PlayArrow'
        });
    }
    
    if (canUserPerformAction(userType, status, 'solicitar-correcoes')) {
        actions.push({
            key: 'solicitar-correcoes',
            label: 'Solicitar Correções',
            color: 'warning',
            icon: 'Edit'
        });
    }
    
    if (canUserPerformAction(userType, status, 'aprovar')) {
        actions.push({
            key: 'aprovar',
            label: 'Aprovar Monografia',
            color: 'success',
            icon: 'CheckCircle'
        });
    }
    
    if (canUserPerformAction(userType, status, 'resubmeter')) {
        actions.push({
            key: 'resubmeter',
            label: 'Resubmeter após Correções',
            color: 'info',
            icon: 'Upload'
        });
    }
    
    if (canUserPerformAction(userType, status, 'submeter-direcao')) {
        actions.push({
            key: 'submeter-direcao',
            label: 'Submeter à Direção Científica',
            color: 'primary',
            icon: 'Send'
        });
    }
    
    return actions;
};

// Exportar como padrão também para compatibilidade
const monografiaService = {
    // Funções existentes
    listarMonografias,
    obterMonografia,
    criarMonografia,
    atualizarMonografia,
    excluirMonografia,
    obterSimilaridadeMonografia,
    encaminharMonografiaParaRevisao,
    devolverMonografia,
    voltarMonografiaParaRevisao,
    registrarParecerMonografia,
    aprovarMonografia,
    listarMonografiasPorRevisor,
    
    // Novas funções
    listarMonografiasPorSupervisor,
    marcarMonografiaEmAnalise,
    solicitarCorrecoes,
    aprovarMonografiaPeloSupervisor,
    resubmeterMonografiaAposCorrecoes,
    submeterParaDirecaoCientifica,
    marcarEmAnalisePelaDirecao,
    devolverPelaDirecao,
    aprovarPelaDirecao,
    obterDocumentoCorrigido,
    
    // Utilitárias
    getStatusDisplayName,
    getStatusColor,
    canUserPerformAction,
    getAvailableActions
};

export default monografiaService;